import { GET_BUS_SEAT_MAP } from '../../seat-selection/actions/getBusSeatMap';
import { SELECT_BUS_SEAT } from '../../seat-selection/actions/selectBusSeat';
import { DESELECT_BUS_SEAT } from '../../seat-selection/actions/deselectBusSeat';
import { CLEAR_SELECTED_SEAT } from '../../seat-selection/actions/clearSelectedSeat';
import { INIT_BOOKING_FLOW } from '../actions/busBookingFlowActions';
import { BUS_BOOKING_FORM_CHANGE_CONTACT_NAME } from '../../booking-form/actions/busBookingFormChangeContactName';
import { BUS_BOOKING_FORM_CHANGE_CONTACT_PHONE } from '../../booking-form/actions/busBookingFormChangeContactPhone';
import { BUS_BOOKING_FORM_TOGGLE_FILL_PAX_DETAILS } from '../../booking-form/actions/busBookingFormToggleFillPaxDetails';
import { BUS_BOOKING_FORM_CHANGE_PAX_DETAILS } from '../../booking-form/actions/busBookingFormChangePaxDetails';
import {
  SET_PAYMENT_MODE,
  SET_RESERVATION_DATE_TIME,
  SET_PAYMENT_METHOD,
} from '../../payment-form/actions/busPaymentFormActions';
import {
  PAYMENT_METHOD_CASH,
  PAYMENTMODE_PAY_NOW,
} from '../../shared/constants/busPaymentModeConstants';
import { LOGOUT_ACTION } from 'modules/general/shared/action/logout';

const initialState = {
  // Seat Selection
  wagons: [],
  selectedSeat: {},
  agentId: '',

  // Booking Form
  contactName: '',
  contactPhone: '',
  fillPaxDetails: false,
  paxDetails: [],

  // Payment Form
  paymentMode: PAYMENTMODE_PAY_NOW,
  bookOnBehalf: false,
  reservationDateTime: 0,
  maxHoldBookingDateTime: 0,
  paymentMethod: PAYMENT_METHOD_CASH,
};

function blankPaxDetails() {
  return {
    name: '',
  };
}

function busBookingFlowReducer(state = initialState, action) {
  switch (action.type) {
    case INIT_BOOKING_FLOW:
      return {
        ...initialState,
        reservationDateTime: action.initialReservationDateTime,
        maxHoldBookingDateTime: action.initialReservationDateTime,
      };

    case GET_BUS_SEAT_MAP: {
      const selectedSeat = action.payload.wagons.reduce(
        (acc, { wagonId }) => ({ ...acc, [wagonId]: [] }),
        {}
      );

      return { ...state, ...action.payload, selectedSeat };
    }
    case SELECT_BUS_SEAT: {
      const wagons = state.selectedSeat[action.payload.wagonId];

      const selectedSeat = {
        ...state.selectedSeat,
        [action.payload.wagonId]: wagons.concat(action.payload.seat),
      };

      const totalSeats = Object.values(selectedSeat).reduce(
        (total, selectedSeatPerWagon) => total + selectedSeatPerWagon.length,
        0
      );

      return {
        ...state,
        selectedSeat,
        paxDetails: [...Array(totalSeats)].map(() => blankPaxDetails()),
      };
    }
    case DESELECT_BUS_SEAT: {
      const wagons = state.selectedSeat[action.payload.wagonId];

      const selectedSeat = {
        ...state.selectSeat,
        [action.payload.wagonId]: wagons.filter(
          seat => seat !== action.payload.seat
        ),
      };

      const totalSeats = Object.values(selectedSeat).reduce(
        (total, selectedSeatPerWagon) => total + selectedSeatPerWagon.length,
        0
      );

      return {
        ...state,
        selectedSeat,
        paxDetails: [...Array(totalSeats)].map(() => blankPaxDetails()),
      };
    }
    case CLEAR_SELECTED_SEAT:
      return { ...state, selectedSeat: {}, paxDetails: [] };

    case BUS_BOOKING_FORM_CHANGE_CONTACT_NAME:
      return {
        ...state,
        contactName: action.contactName,
      };
    case BUS_BOOKING_FORM_CHANGE_CONTACT_PHONE:
      return {
        ...state,
        contactPhone: action.contactPhone,
      };
    case BUS_BOOKING_FORM_TOGGLE_FILL_PAX_DETAILS:
      return {
        ...state,
        fillPaxDetails: !state.fillPaxDetails,
      };
    case BUS_BOOKING_FORM_CHANGE_PAX_DETAILS:
      return {
        ...state,
        paxDetails: state.paxDetails.map(
          (details, i) => (i === action.index ? action.details : details)
        ),
      };

    // Payment Form
    case SET_PAYMENT_MODE:
      return { ...state, paymentMode: action.paymentMode };
    case SET_RESERVATION_DATE_TIME:
      return { ...state, reservationDateTime: action.dateTime };
    case SET_PAYMENT_METHOD:
      return { ...state, paymentMethod: action.paymentMethod };
    case LOGOUT_ACTION:
      return initialState;
    default:
      return state;
  }
}

export default busBookingFlowReducer;
